import { useContext } from 'react';
import Scrollbar from 'shared-compoents/Scrollbar';
import { SidebarContext } from 'contexts/SidebarContext';

import { Box, useTheme } from '@mui/material';
import SidebarMenu from './SidebarMenu';
import { SidebarToggle, FixedSidebarWrapper, DrawerWrapper, DividerStyled, SidebarWrapper, SidebarProfileWrapper, SidebarProfileImg, SidebarProfileInfo, SidebarProfileInfoName, SidebarProfileInfoEmail, SingoutWrapper, SingoutLabel } from './styles';
import { darken } from '@mui/material/styles';
import { useMsal } from '@azure/msal-react';
import { useLogout } from 'shared-compoents/logout';
import { useProfilePhoto } from 'shared-compoents/useProfilePhoto';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

interface SidebarProps {
  collapsed: boolean;
  toggleSidebarSize: any;
}

function Sidebar({ collapsed, toggleSidebarSize }: Readonly<SidebarProps>) {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const closeSidebar = () => toggleSidebar();
  const theme = useTheme();
  const { accounts } = useMsal();
  const profilePhoto = useProfilePhoto();
  const user = {
    name: accounts[0]?.name || "",
    avatar: "/assets/signout.svg",
    email: accounts[0]?.username || "",
  };

  const logout = useLogout();

  return (
    <>
      <FixedSidebarWrapper collapsed={collapsed}>
        <SidebarToggle onClick={toggleSidebarSize}>
          {collapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </SidebarToggle>
        <Box
          className="sidebar-common"
          sx={{
            display: collapsed ? 'none' : 'block'
          }}
        >
          <Scrollbar>
            <a href='/'>
              <img src='/assets/enclave-logo.png' alt='Enclave Logo' width={224} />
            </a>
            <SidebarProfileWrapper>
              <SidebarProfileImg src={profilePhoto || '/assets/user-profile.svg'} alt='profile-icon' />
              <SidebarProfileInfo>
                <SidebarProfileInfoName>{user.name}</SidebarProfileInfoName>
                <SidebarProfileInfoEmail title={user.email}>{user.email}</SidebarProfileInfoEmail>
                <SingoutWrapper onClick={logout}>
                  <img src={user.avatar} alt='signout' />
                  <SingoutLabel>Sign out</SingoutLabel>
                </SingoutWrapper>
              </SidebarProfileInfo>
            </SidebarProfileWrapper>
            <SidebarMenu />
          </Scrollbar>
        </Box>
      </FixedSidebarWrapper>
      <DrawerWrapper
        anchor={theme.direction === "rtl" ? "right" : "left"}
        open={sidebarToggle}
        onClose={closeSidebar}
        variant="temporary"
        elevation={9}
      >
        <SidebarWrapper
          sx={{
            background:
              theme.palette.mode === "dark"
                ? theme.colors.alpha.white[100]
                : darken(theme.colors.alpha.black[100], 0.5),
          }}
        >
          <Box mt={3}></Box>
          <DividerStyled />
          <SidebarMenu />
        </SidebarWrapper>
      </DrawerWrapper>
    </>
  );
}

export default Sidebar;
